import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { Deferred, RpcError, RpcOutputStreamController, ServerStreamingCall, UnaryCall, mergeRpcOptions } from "@protobuf-ts/runtime-rpc";
import { GrpcWebFrame, createGrpcWebRequestBody, createGrpcWebRequestHeader, readGrpcWebResponseBody, readGrpcWebResponseHeader, readGrpcWebResponseTrailer } from "./grpc-web-format";
import { GrpcStatusCode } from "./goog-grpc-status-code";
/**
 * Implements the grpc-web protocol, supporting text format or binary
 * format on the wire. Uses the fetch API to do the HTTP requests.
 *
 * Does not support client streaming or duplex calls because grpc-web
 * does not support them.
 */

export var GrpcWebFetchTransport = /*#__PURE__*/function () {
  function GrpcWebFetchTransport(defaultOptions) {
    _classCallCheck(this, GrpcWebFetchTransport);

    this.defaultOptions = defaultOptions;
  }

  _createClass(GrpcWebFetchTransport, [{
    key: "mergeOptions",
    value: function mergeOptions(options) {
      return mergeRpcOptions(this.defaultOptions, options);
    }
    /**
     * Create an URI for a gRPC web call.
     *
     * Takes the `baseUrl` option and appends:
     * - slash "/"
     * - package name
     * - dot "."
     * - service name
     * - slash "/"
     * - method name
     *
     * If the service was declared without a package, the package name and dot
     * are omitted.
     *
     * All names are used exactly like declared in .proto.
     */

  }, {
    key: "makeUrl",
    value: function makeUrl(method, options) {
      var base = options.baseUrl;
      if (base.endsWith('/')) base = base.substring(0, base.length - 1);
      return "".concat(base, "/").concat(method.service.typeName, "/").concat(method.name);
    }
  }, {
    key: "clientStreaming",
    value: function clientStreaming(method
    /*, options: RpcOptions*/
    ) {
      var e = new RpcError('Client streaming is not supported by grpc-web', GrpcStatusCode[GrpcStatusCode.UNIMPLEMENTED]);
      e.methodName = method.name;
      e.serviceName = method.service.typeName;
      throw e;
    }
  }, {
    key: "duplex",
    value: function duplex(method
    /*, options: RpcOptions*/
    ) {
      var e = new RpcError('Duplex streaming is not supported by grpc-web', GrpcStatusCode[GrpcStatusCode.UNIMPLEMENTED]);
      e.methodName = method.name;
      e.serviceName = method.service.typeName;
      throw e;
    }
  }, {
    key: "serverStreaming",
    value: function serverStreaming(method, input, options) {
      var _a, _b, _c, _d;

      var opt = options,
          format = (_a = opt.format) !== null && _a !== void 0 ? _a : 'text',
          fetchInit = (_b = opt.fetchInit) !== null && _b !== void 0 ? _b : {},
          url = this.makeUrl(method, opt),
          inputBytes = method.I.toBinary(input, opt.binaryOptions),
          defHeader = new Deferred(),
          responseStream = new RpcOutputStreamController(),
          responseEmptyBody = true,
          maybeStatus,
          defStatus = new Deferred(),
          maybeTrailer,
          defTrailer = new Deferred();
      globalThis.fetch(url, Object.assign(Object.assign({}, fetchInit), {
        method: 'POST',
        headers: createGrpcWebRequestHeader(new globalThis.Headers(), format, opt.timeout, opt.meta),
        body: createGrpcWebRequestBody(inputBytes, format),
        signal: (_c = options.abort) !== null && _c !== void 0 ? _c : null // node-fetch@3.0.0-beta.9 rejects `undefined`

      })).then(function (fetchResponse) {
        var _readGrpcWebResponseH = readGrpcWebResponseHeader(fetchResponse),
            _readGrpcWebResponseH2 = _slicedToArray(_readGrpcWebResponseH, 3),
            code = _readGrpcWebResponseH2[0],
            detail = _readGrpcWebResponseH2[1],
            meta = _readGrpcWebResponseH2[2];

        defHeader.resolve(meta);
        if (code != null && code !== GrpcStatusCode.OK) throw new RpcError(detail !== null && detail !== void 0 ? detail : GrpcStatusCode[code], GrpcStatusCode[code], meta);
        if (code != null) maybeStatus = {
          code: GrpcStatusCode[code],
          detail: detail !== null && detail !== void 0 ? detail : GrpcStatusCode[code]
        };
        return fetchResponse;
      }).then(function (fetchResponse) {
        if (!fetchResponse.body) throw new RpcError('missing response body', GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        return readGrpcWebResponseBody(fetchResponse.body, fetchResponse.headers.get('content-type'), function (type, data) {
          switch (type) {
            case GrpcWebFrame.DATA:
              responseStream.notifyMessage(method.O.fromBinary(data, opt.binaryOptions));
              responseEmptyBody = false;
              break;

            case GrpcWebFrame.TRAILER:
              var code, detail;

              var _readGrpcWebResponseT = readGrpcWebResponseTrailer(data);

              var _readGrpcWebResponseT2 = _slicedToArray(_readGrpcWebResponseT, 3);

              code = _readGrpcWebResponseT2[0];
              detail = _readGrpcWebResponseT2[1];
              maybeTrailer = _readGrpcWebResponseT2[2];
              maybeStatus = {
                code: GrpcStatusCode[code],
                detail: detail !== null && detail !== void 0 ? detail : GrpcStatusCode[code]
              };
              break;
          }
        });
      }).then(function () {
        if (!maybeTrailer && !responseEmptyBody) throw new RpcError("missing trailers", GrpcStatusCode[GrpcStatusCode.DATA_LOSS]); // istanbul ignore if - this should be impossible and only here to satisfy TypeScript

        if (!maybeStatus) throw new RpcError("missing status", GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        if (maybeStatus.code !== 'OK') throw new RpcError(maybeStatus.detail, maybeStatus.code, maybeTrailer);
        responseStream.notifyComplete();
        defStatus.resolve(maybeStatus);
        defTrailer.resolve(maybeTrailer || {});
      }).catch(function (reason) {
        var error;
        if (reason instanceof RpcError) error = reason;else if (reason instanceof Error && reason.name === 'AbortError') // aborted
          error = new RpcError(reason.message, GrpcStatusCode[GrpcStatusCode.CANCELLED]);else // RpcErrors are thrown by us, everything else is an internal error
          error = new RpcError(reason instanceof Error ? reason.message : "" + reason, GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        error.methodName = method.name;
        error.serviceName = method.service.typeName;
        defHeader.rejectPending(error);
        responseStream.notifyError(error);
        defStatus.rejectPending(error);
        defTrailer.rejectPending(error);
      });
      return new ServerStreamingCall(method, (_d = opt.meta) !== null && _d !== void 0 ? _d : {}, input, defHeader.promise, responseStream, defStatus.promise, defTrailer.promise);
    }
  }, {
    key: "unary",
    value: function unary(method, input, options) {
      var _a, _b, _c, _d;

      var opt = options,
          format = (_a = opt.format) !== null && _a !== void 0 ? _a : 'text',
          fetchInit = (_b = opt.fetchInit) !== null && _b !== void 0 ? _b : {},
          url = this.makeUrl(method, opt),
          inputBytes = method.I.toBinary(input, opt.binaryOptions),
          defHeader = new Deferred(),
          maybeMessage,
          defMessage = new Deferred(),
          maybeStatus,
          defStatus = new Deferred(),
          maybeTrailer,
          defTrailer = new Deferred();
      globalThis.fetch(url, Object.assign(Object.assign({}, fetchInit), {
        method: 'POST',
        headers: createGrpcWebRequestHeader(new globalThis.Headers(), format, opt.timeout, opt.meta),
        body: createGrpcWebRequestBody(inputBytes, format),
        signal: (_c = options.abort) !== null && _c !== void 0 ? _c : null // node-fetch@3.0.0-beta.9 rejects `undefined`

      })).then(function (fetchResponse) {
        var _readGrpcWebResponseH3 = readGrpcWebResponseHeader(fetchResponse),
            _readGrpcWebResponseH4 = _slicedToArray(_readGrpcWebResponseH3, 3),
            code = _readGrpcWebResponseH4[0],
            detail = _readGrpcWebResponseH4[1],
            meta = _readGrpcWebResponseH4[2];

        defHeader.resolve(meta);
        if (code != null && code !== GrpcStatusCode.OK) throw new RpcError(detail !== null && detail !== void 0 ? detail : GrpcStatusCode[code], GrpcStatusCode[code], meta);
        if (code != null) maybeStatus = {
          code: GrpcStatusCode[code],
          detail: detail !== null && detail !== void 0 ? detail : GrpcStatusCode[code]
        };
        return fetchResponse;
      }).then(function (fetchResponse) {
        if (!fetchResponse.body) throw new RpcError('missing response body', GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        return readGrpcWebResponseBody(fetchResponse.body, fetchResponse.headers.get('content-type'), function (type, data) {
          switch (type) {
            case GrpcWebFrame.DATA:
              if (maybeMessage) throw new RpcError("unary call received 2nd message", GrpcStatusCode[GrpcStatusCode.DATA_LOSS]);
              maybeMessage = method.O.fromBinary(data, opt.binaryOptions);
              break;

            case GrpcWebFrame.TRAILER:
              var code, detail;

              var _readGrpcWebResponseT3 = readGrpcWebResponseTrailer(data);

              var _readGrpcWebResponseT4 = _slicedToArray(_readGrpcWebResponseT3, 3);

              code = _readGrpcWebResponseT4[0];
              detail = _readGrpcWebResponseT4[1];
              maybeTrailer = _readGrpcWebResponseT4[2];
              maybeStatus = {
                code: GrpcStatusCode[code],
                detail: detail !== null && detail !== void 0 ? detail : GrpcStatusCode[code]
              };
              break;
          }
        });
      }).then(function () {
        if (!maybeTrailer && maybeMessage) throw new RpcError("missing trailers", GrpcStatusCode[GrpcStatusCode.DATA_LOSS]); // istanbul ignore if - this should be impossible and only here to satisfy TypeScript

        if (!maybeStatus) throw new RpcError("missing status", GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        if (!maybeMessage && maybeStatus.code === 'OK') throw new RpcError('expected error status', GrpcStatusCode[GrpcStatusCode.DATA_LOSS]);
        if (!maybeMessage) throw new RpcError(maybeStatus.detail, maybeStatus.code, maybeTrailer);
        defMessage.resolve(maybeMessage);
        if (maybeStatus.code !== 'OK') throw new RpcError(maybeStatus.detail, maybeStatus.code, maybeTrailer);
        defStatus.resolve(maybeStatus);
        defTrailer.resolve(maybeTrailer || {});
      }).catch(function (reason) {
        var error;
        if (reason instanceof RpcError) error = reason;else if (reason instanceof Error && reason.name === 'AbortError') // aborted
          error = new RpcError(reason.message, GrpcStatusCode[GrpcStatusCode.CANCELLED]);else // RpcErrors are thrown by us, everything else is an internal error
          error = new RpcError(reason instanceof Error ? reason.message : "" + reason, GrpcStatusCode[GrpcStatusCode.INTERNAL]);
        error.methodName = method.name;
        error.serviceName = method.service.typeName;
        defHeader.rejectPending(error);
        defMessage.rejectPending(error);
        defStatus.rejectPending(error);
        defTrailer.rejectPending(error);
      });
      return new UnaryCall(method, (_d = opt.meta) !== null && _d !== void 0 ? _d : {}, input, defHeader.promise, defMessage.promise, defStatus.promise, defTrailer.promise);
    }
  }]);

  return GrpcWebFetchTransport;
}();